import { observer } from 'mobx-react-lite'
import classnames from 'classnames'
import { Box, Icon, NameValueRecord, Typography } from 'shared/ui'
import { numberFormat } from 'shared/lib'
import { type DetailsSurveyModalStore } from '../../store/detailsSurveyModalStore'
import styles from './styles.module.scss'

export const ContactEnrollmentTab = observer(({ store }: { store: DetailsSurveyModalStore }) => {
  return (
    <div className={styles.tabContent}>
      <div className={styles.section}>
        <Typography ariaLabel={'npsQuestion'} variant={'body-rg-medium'}>
          NPS question
        </Typography>
        <div className={styles.questionBox}>
          <Typography ariaLabel={'questionText'} variant={'body-rg-regular'}>
            {store.npsQuestion}
          </Typography>
        </div>
      </div>

      <Box display={'flex'} flexDirection={'column'}>
        <Typography ariaLabel={'send'} variant={'body-rg-medium'} marginBottom={'12px'}>
          Send
        </Typography>
        <div className={styles.grid}>
          <Typography
            ariaLabel={'sendFrom'}
            variant={'text-input-field-r'}
            className={classnames(styles.valueWrap, styles.label)}
          >
            Send from
          </Typography>
          <div className={styles.valueWrap}>
            <NameValueRecord {...store.sendFromInfo} />
          </div>
        </div>
        <div className={styles.contactGrid}>
          <Typography
            ariaLabel={'contacts'}
            variant={'text-input-field-r'}
            className={classnames(styles.valueWrap, styles.label)}
          >
            Contacts
          </Typography>
          <div className={classnames(styles.valueWrap, styles.contactsValue)}>
            <Icon icon={'contacts'} tertiary fontSize={16} />
            <Typography ariaLabel={'contactsCount'} variant={'body-md-regular'}>
              {numberFormat({ value: store.contactsCount })}
            </Typography>
          </div>
        </div>
      </Box>
    </div>
  )
})
